import Financials from "./Financials"
import Referrals from "./Referrals"
import Details from "./Details"

export {
  Financials,
  Referrals,
  Details,
}
